import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { api } from '../../services/api';
import { Input } from '../../components/ui/Input';
import { Button } from '../../components/ui/Button';
import { Card, CardContent } from '../../components/ui/Card';

const Container = styled.div`
  max-width: 800px;
  margin: 0 auto;
`;

const FormGroup = styled.div`
  margin-bottom: 1rem;
  label { display: block; margin-bottom: 0.5rem; font-weight:500; }
`;

const UserItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #eee;
  &:last-child { border-bottom: none; }
`;

const UsersAdmin = () => {
  const [users, setUsers] = useState([]);
  const [newUser, setNewUser] = useState({ username: '', password: '', role: 'admin' });
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState('');

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    try {
      const res = await api.get('/users');
      setUsers(res);
    } catch (err) { console.error(err); } finally { setLoading(false); }
  };

  const handleCreate = async () => {
    if (!newUser.username || !newUser.password) return alert('Fill required fields');
    try {
      await api.post('/users', newUser);
      setMsg('User created');
      setNewUser({ username: '', password: '', role: 'admin' });
      loadData();
    } catch (err) { setMsg('Error creating user'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete user?')) return;
    try {
      await api.delete(`/users/${id}`);
      loadData();
    } catch (err) { console.error(err); }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <Container>
      <h2>Manage Users</h2>
      {msg && <div style={{color:'green'}}>{msg}</div>}

      <Card style={{marginBottom:'2rem'}}>
        <CardContent>
          <h3>Create New User</h3>
          <FormGroup><label>Username</label><Input value={newUser.username} onChange={e=>setNewUser({...newUser, username:e.target.value})} /></FormGroup>
          <FormGroup><label>Password</label><Input type="password" value={newUser.password} onChange={e=>setNewUser({...newUser, password:e.target.value})} /></FormGroup>
          <FormGroup>
            <label>Role</label>
            <select 
                value={newUser.role} 
                onChange={e=>setNewUser({...newUser, role:e.target.value})}
                style={{padding:'0.8rem', width:'100%', borderRadius:'4px', border:'1px solid #ddd'}}
            >
                <option value="admin">Admin</option>
                <option value="superAdmin">Super Admin</option>
            </select>
          </FormGroup>
          <Button onClick={handleCreate}>Create User</Button>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <h3>Existing Users</h3>
          {users.map(user => (
            <UserItem key={user._id}>
               <div>
                   <strong>{user.username}</strong> <span style={{color:'#666', marginLeft:'0.5rem'}}>({user.role})</span>
               </div>
               <Button onClick={()=>handleDelete(user._id)} $variant="danger">Delete</Button>
            </UserItem>
          ))}
        </CardContent>
      </Card>
    </Container>
  );
};

export default UsersAdmin;
